import { ErrorCode, ErrorCodeDetails } from './ErrorCode'

import { UnrecoverableErrorStore } from '@/components/shared/UnrecoverableError/store'
import { ErrorPrefix } from '@/constants/errors/prefix'

/**
 * This is a base class — only able to extends — for all unrecoverable errors in the app/page.
 *
 * An unrecoverable error is an error that blocks the user and prevents the app from continuing
 * its normal operation.
 *
 * Generally, these errors are presented to the user through the {@link UnrecoverableErrorPage} or a modal.
 *
 * @see docs/ERRORS.md and docs/ERROR_CODES.md for more details.
 */
export abstract class UnrecoverableError extends ErrorCode {
  protected constructor(errorPayload: unknown) {
    super(undefined, errorPayload)
  }

  abstract readonly prefix: ErrorPrefix

  /**
   * Page suffix is only set when the unrecoverable store is started
   * Check the `startupUnrecoverableErrorStore` from {@link createUseShouldRender}
   */
  getPageSuffix() {
    return UnrecoverableErrorStore.getState().pageSuffix
  }

  protected abstract getCode(): string | undefined

  protected abstract getStatusCode(): number | string | undefined

  override getErrorCodeDetails(): ErrorCodeDetails {
    return {
      prefix: this.prefix,
      suffix: this.getPageSuffix(),
      code: this.getCode(),
      httpStatusCode: this.getStatusCode(),
    }
  }
}
